import { useMarketplaceLabel, marketplaceChartRows } from "../../configurazione/marketplaceDisplay";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import apiUrl from "../../../Apiurl";
import ReactDOM from 'react-dom';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import {
    blueberryTwilightPalette,
    mangoFusionPalette,
    cheerfulFiestaPalette,
  } from '@mui/x-charts/colorPalettes';
import valutizzaStringaONumero from "../../../interfaccia/funzioniComuni/valutizzaStringaONumero";
import {
    BlockSkeleton,
    DonutChartSkeleton,
    TextSkeleton,
} from "../../../interfaccia/loading";
import "./Ordinidelgiorno.css";

const pieMargin = { top: 5, right: 5, bottom: 5, left: 5 };

function OrdinidelgiornoSkeleton({ datiOrdiniInCorso }) {
    return (
        <div className="dashboard-ordini-pie-panel sfondoBiancoTema tc pt2 pb3">
            <div className="mb3 flex flex-column items-center">
                <BlockSkeleton tone="soft" width={datiOrdiniInCorso ? 360 : 300} height={24} className="mb2" />
                {datiOrdiniInCorso ? (
                    <div className="w-100 flex flex-wrap justify-center">
                        {Array.from({ length: 5 }).map((_, index) => (
                            <BlockSkeleton
                                key={`ordini-kpi-${index}`}
                                tone="soft"
                                width={140}
                                height={16}
                                className="mb2 mh2"
                            />
                        ))}
                    </div>
                ) : (
                    <BlockSkeleton tone="soft" width={260} height={18} />
                )}
            </div>
            <div className="dashboard-ordini-pie-grid">
                {[
                    [
                        { innerRadius: 80, outerRadius: 110, segments: 4, offset: 0.02 },
                        { innerRadius: 0, outerRadius: 70, segments: 3, offset: 0.08 },
                    ],
                    [{ innerRadius: 40, outerRadius: 110, segments: 4, offset: 0.04 }],
                    [
                        { innerRadius: 80, outerRadius: 110, segments: 4, offset: 0.06 },
                        { innerRadius: 0, outerRadius: 70, segments: 3, offset: 0.12 },
                    ],
                    [
                        { innerRadius: 0, outerRadius: 70, segments: 4, offset: 0.03 },
                        { innerRadius: 80, outerRadius: 110, segments: 4, offset: 0.09 },
                    ],
                    [{ innerRadius: 40, outerRadius: 110, segments: 5, offset: 0.05 }],
                    [
                        { innerRadius: 80, outerRadius: 110, segments: 4, offset: 0.07 },
                        { innerRadius: 0, outerRadius: 70, segments: 3, offset: 0.11 },
                    ],
                ].map((rings, index) => (
                    <div key={`ordini-pie-${index}`} className="dashboard-ordini-pie-item pt2 pb2">
                        <div className="flex flex-column items-center">
                            <BlockSkeleton tone="soft" width={140} height={16} className="mb2" />
                            <DonutChartSkeleton
                                tone="soft"
                                width={300}
                                height={240}
                                legendRows={index === 1 || index === 4 || index === 5 ? 4 : 3}
                                rings={rings}
                            />
                            <div className="mt2 w-100" style={{ maxWidth: 280 }}>
                                <TextSkeleton tone="soft" lines={index === 1 || index === 4 ? 4 : 3} lineHeight={12} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
  
function Ordinidelgiorno({
    token,
    dataStart,
    dataEnd,
    datiOrdiniInCorso,
    onLoad
}) {
    
    const marketplaceLabel = useMarketplaceLabel();
    function parsePotentiallyGroupedFloat(stringValue) {
        stringValue = stringValue.trim();
        var result = stringValue.replace(/[^0-9]/g, '');
        if (/[,\.]\d{2}$/.test(stringValue)) {
            result = result.replace(/(\d{2})$/, '.$1');
        }
        return parseFloat(result);
    }

    const [data, setData] = useState(false)

    const [loading, setLoading] = useState(false);

  ////////////////////       FETCH INIZIALE      ///////////////////////////
  const fetchData = async () => {
    setLoading(true);
    const nuoviParams = new URLSearchParams({
      dataStart: dataStart,
      dataEnd: dataEnd,
      datiOrdiniInCorso: datiOrdiniInCorso
    })
    const response = await axios.get(apiUrl + "/logistica/dashboard/statisticheOrdini?" + nuoviParams);
    console.log(response.data)
    setData(response.data);
    setLoading(false);  
    if(onLoad) onLoad();    
};

useEffect(() => {
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    fetchData()
}, [token,dataStart,dataEnd]);

const formatNumberOrSlash = (value) => {
    if (value === null || value === undefined) return "/";
    return value;
}

const formatCurrencyOrSlash = (value) => {
    if (value === null || value === undefined) return "/";
    return valutizzaStringaONumero(value,"EUR",true);
}

    if (loading) {
        return <OrdinidelgiornoSkeleton datiOrdiniInCorso={datiOrdiniInCorso} />;
    }

    if (data) {
        return (
            <div className="dashboard-ordini-pie-panel sfondoBiancoTema tc pt2 pb3">
                {/* Statistiche testuali all'inizio */}
                {datiOrdiniInCorso && <div className="f2">Ci sono <b>{data.tot[0].totSpedizioni}</b> ordini da spedire.</div>}
                {!datiOrdiniInCorso && <div className="f3 mb4">Dati sugli ordini dal {dataStart} al {dataEnd}.</div>}
                {datiOrdiniInCorso && <div className="pt2 pb3 mb2  tc  flex justify-center">
                        <div className="ml2">Tot spedizioni: <strong>{data.tot[0].totSpedizioni + " ordini ("+data.tot[0].totColli + " colli)"}</strong></div>
                        {/* <div className="ml2">Tot colli: <strong>{data.tot[0].totColli + " colli"}</strong></div> */}
                        <div className="ml2">Tot BRT: <strong>{data.brt[0].sped }</strong></div>
                        <div className="ml2">Tot DHL: <strong>{data.dhl[0].sped }</strong></div>
                        <div className="ml2">Tot UPS: <strong>{data.ups[0].sped }</strong></div>
                        <div className="ml2">Importo totale: <strong>{data.tot[0].totImporto && valutizzaStringaONumero(data.tot[0].totImporto,"EUR",true)}</strong></div>
                </div>}
                {/* ///////////////////////////////////////// */}
                {!datiOrdiniInCorso && data.riquadriStats && (
                    <div className="w-100 flex flex-wrap justify-center tc mb3">
                        <div className="ba b--black-10 br2 pa2 ma2 mw5">
                            <div className="b ttu mb2">Media carrello</div>
                            <div>Complessivo: <strong>{formatCurrencyOrSlash(data.riquadriStats.mediaCarrello.complessivo)}</strong></div>
                            <div>{marketplaceLabel("PrestaShop - vs.com")}: <strong>{formatCurrencyOrSlash(data.riquadriStats.mediaCarrello.prestashop)}</strong></div>
                            <div>{marketplaceLabel("Amazon")}: <strong>{formatCurrencyOrSlash(data.riquadriStats.mediaCarrello.amazon)}</strong></div>
                        </div>
                        <div className="ba b--black-10 br2 pa2 ma2 mw5">
                            <div className="b ttu mb2">Numero spedizioni</div>
                            <div>Complessivo: <strong>{formatNumberOrSlash(data.riquadriStats.numeroSpedizioni.complessivo)}</strong></div>
                            <div>{marketplaceLabel("PrestaShop - vs.com")}: <strong>{formatNumberOrSlash(data.riquadriStats.numeroSpedizioni.prestashop)}</strong></div>
                            <div>{marketplaceLabel("Amazon")}: <strong>{formatNumberOrSlash(data.riquadriStats.numeroSpedizioni.amazon)}</strong></div>
                        </div>
                        <div className="ba b--black-10 br2 pa2 ma2 mw5">
                            <div className="b ttu mb2">Totale importi</div>
                            <div>Complessivo: <strong>{formatCurrencyOrSlash(data.riquadriStats.totaleImporti.complessivo)}</strong></div>
                            <div>{marketplaceLabel("PrestaShop - vs.com")}: <strong>{formatCurrencyOrSlash(data.riquadriStats.totaleImporti.prestashop)}</strong></div>
                            <div>{marketplaceLabel("Amazon")}: <strong>{formatCurrencyOrSlash(data.riquadriStats.totaleImporti.amazon)}</strong></div>
                        </div>
                    </div>
                )}
            <div className="dashboard-ordini-pie-grid">
            <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">Magazzino</div>
                    <PieChart
                        series={[
                            
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value}`
                                        )
                                },
                                data: data.resultsRicercaOrdiniMagazzino.filter(i => i.value && i.value > 0),
                                innerRadius: 80,
                                outerRadius: 110,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let emoji;
                                        switch (item.code) {
                                            case "Villanova Mondovì":
                                                emoji = "VM"
                                                break;
                                                case "Torino":
                                                    emoji = "JS"
                                                    break;
                                                    case "Prato Nevoso":
                                                    emoji = "PN"
                                                    break;
                                            default: emoji = ""
                                                break;
                                        }
                                        return (
                                            `${emoji}`
                                        )}
                                },
                                data: data.resultsRicercaOrdiniMagazzinoImp.filter(i => i.value && i.value > 0),
                                innerRadius: 0,
                                outerRadius: 70,
                            },
                        ]}
                        colors={mangoFusionPalette} // oppure cheerfulFiestaPalette oppure mangoFusionPalette
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                    <div className="flex flex-wrap mt2">
                        <div className="w-50 tr pr2 br">
                            {data.resultsRicercaOrdiniMagazzino.map(nazione=><div><b>{nazione.label}</b>: {nazione.value}</div>)}
                        </div>
                        <div className="w-50 tl pl2">
                            {data.resultsRicercaOrdiniMagazzinoImp.map(nazione=><div><b>{nazione.label}</b>: {nazione.value ? valutizzaStringaONumero(nazione.value,"EUR",true) : "/"}</div>)}
                       </div>
                    </div>
                    
                </div>
                <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">Stato ordini</div>
                    <PieChart
                        series={[
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let text;
                                        switch (item.code) {
                                            case "PREPARAZIONE":
                                                text = "P"
                                                break;
                                                case "IN ATTESA":
                                                    text = "A"
                                                    break;
                                                    case "RICERCA":
                                                text = "R"
                                                break;
                                            default: text = ""
                                                break;
                                        }
                                        return (
                                            `${text}`
                                        )
                                    }
                                },
                                data: data.resultsRicercaOrdiniStato.filter(i => i.value && i.value > 0),
                                innerRadius: 40,
                                outerRadius: 110,
                            }
                        ]}

                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                <div className="mt2">
                            {data.resultsRicercaOrdiniStato.map(tipo=><div><b>{tipo.label}</b>: {tipo.value}</div>)}
                    </div>
                </div>
                <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">Marketplace</div>
                    <PieChart
                        series={[
                            
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value}`
                                        )
                                },
                                data: marketplaceChartRows(data.resultsRicercaOrdiniMarketplace, marketplaceLabel).filter(i => i.value && i.value > 0),
                                innerRadius: 80,
                                outerRadius: 110,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let emoji;
                                        switch (item.code) {
                                            case "PrestaShop - vs.com":
                                                emoji = "PS"
                                                break;
                                                case "Amazon":
                                                    emoji = "AMZ"
                                                    break;
                                                    case "Colizey":
                                                    emoji = "COL"
                                                    break;
                                            default: emoji = ""
                                                break;
                                        }
                                        return (
                                            `${emoji}`
                                        )}
                                },
                                data: marketplaceChartRows(data.resultsRicercaOrdiniMarketplaceImp, marketplaceLabel).filter(i => i.value && i.value > 0),
                                innerRadius: 0,
                                outerRadius: 70,
                            },
                        ]}
                        colors={cheerfulFiestaPalette} // oppure cheerfulFiestaPalette oppure mangoFusionPalette
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                    <div className="flex flex-wrap mt2">
                        <div className="w-50 tr pr2 br">
                            {data.resultsRicercaOrdiniMarketplace.map(nazione=><div><b>{marketplaceLabel(Object.prototype.hasOwnProperty.call(nazione, 'code') ? nazione.code : nazione.label, nazione.label)}</b>: {nazione.value}</div>)}
                        </div>
                        <div className="w-50 tl pl2">
                            {data.resultsRicercaOrdiniMarketplaceImp.map(nazione=><div><b>{marketplaceLabel(Object.prototype.hasOwnProperty.call(nazione, 'code') ? nazione.code : nazione.label, nazione.label)}</b>: {nazione.value ? valutizzaStringaONumero(nazione.value,"EUR",true) : "/"}</div>)}
                       </div>
                    </div>
                    
                </div>
                <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">CORRIERI</div>
                    <PieChart
                        series={[
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `${item.label} - 
                                        ${item.value}`
                                        )
                                },
                                data: [
                                    { value: data.brt[0].sped, label: 'BRT', color: '#ff4136' },
                                    { value: data.dhl[0].sped, label: 'DHL', color: '#ffb700' },
                                    { value: data.ups[0].sped, label: 'UPS', color: '#5c3419' },
                                    { value: data.altriCorrieri[0].sped, label: 'ALTRI', color: '#00449e' },
                                ].filter(i => i.value && i.value > 0),
                                innerRadius: 0,
                                outerRadius: 70,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value} c.`
                                        )
                                },
                                data: [
                                    { value: data.brt[0].colli, label: 'BRT', color: '#ff4136' },
                                    { value: data.dhl[0].colli, label: 'DHL', color: '#ffb700' },
                                    { value: data.ups[0].colli, label: 'UPS', color: '#5c3419' },
                                    { value: data.altriCorrieri[0].colli, label: 'ALTRI', color: '#00449e' },
                                ].filter(i => i.value && i.value > 0),
                                innerRadius: 80,
                                outerRadius: 110,
                            },
                        ]}

                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'white',
                                fontWeight: 'bold',
                            },
                            
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                    <div className="mt2">(n. colli / n. ordini)</div>
                </div>
                <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">Tipi ordine</div>
                    <PieChart
                        series={[
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let text;
                                        switch (item.code) {
                                            case "Ordine Web":
                                                text = "W"
                                                break;
                                                case "Invio per sostituzione":
                                                    text = "Sost"
                                                    break;
                                                    case "Nuova spedizione":
                                                text = "N.S."
                                                break;
                                            default: text = ""
                                                break;
                                        }
                                        return (
                                            `${text}`
                                        )
                                    }
                                },
                                data: data.tipiOrdine.filter(i => i.value && i.value > 0),
                                innerRadius: 40,
                                outerRadius: 110,
                            }
                        ]}

                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                <div className="mt2">
                            {data.tipiOrdine.map(tipo=><div><b>{tipo.label}</b>: {tipo.value}</div>)}
                    </div>
                </div>
                <div className="dashboard-ordini-pie-item pt2 pb2">
                    <div className="tc b ttu">Provenienza</div>
                    <PieChart
                        series={[
                            
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0)
                                        return (
                                            `
                                        ${item.value}`
                                        )
                                },
                                data: data.resultsRicercaOrdiniNazione.filter(i => i.value && i.value > 0),
                                innerRadius: 80,
                                outerRadius: 110,
                            },
                            {
                                arcLabel: (item) => {
                                    if (item.value && typeof item.value === 'number' && item.value > 0) {
                                        let emoji;
                                        switch (item.code) {
                                            case "Italia":
                                                emoji = "IT"
                                                break;
                                                case "Francia":
                                                    emoji = "FR"
                                                    break;
                                                    case "Germania":
                                                    emoji = "DE"
                                                    break;
                                                    case "Spagna":
                                                    emoji = "ES"
                                                    break;
                                            default: emoji = ""
                                                break;
                                        }
                                        return (
                                            `${emoji}`
                                        )}
                                },
                                data: data.resultsRicercaCorrispettivi.filter(i => i.value && i.value > 0),
                                innerRadius: 0,
                                outerRadius: 70,
                            },
                        ]}
                        colors={cheerfulFiestaPalette} // oppure cheerfulFiestaPalette oppure mangoFusionPalette
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'black',
                                fontWeight: 'bold',
                            },
                        }}
                        width={300}
                        height={240}
                        margin={pieMargin}
                        legend={{ hidden: true }}
                    />
                    <div className="flex flex-wrap mt2">
                        <div className="w-50 tr pr2 br">
                            {data.resultsRicercaOrdiniNazione.map(nazione=><div><b>{nazione.label}</b>: {nazione.value}</div>)}
                        </div>
                        <div className="w-50 tl pl2">
                            {data.resultsRicercaCorrispettivi.map(nazione=><div><b>{nazione.label}</b>: {nazione.value ? valutizzaStringaONumero(nazione.value,"EUR",true) : "/"}</div>)}
                       </div>
                    </div>
                    
                </div>
                
            </div>
            </div>
        )
    }

    return (<div>no data</div>)

}

export default Ordinidelgiorno;
